import React from "react";

const ProfileThemes = ({ children }) => (
  <section className="profile-themes">{children}</section>
);

export default ProfileThemes;
